import { createContext, useState } from "react";

const FavoritesContext = createContext({
    favorite: [],
    totalFavorites: 0,
    addFavorite: (favoriteMeetup) => { },
    removeFavorite: (meetupId) => { },
    itemIsFavorite: (meetupId) => { }
});

export function FavoritesContextProvider(props) {
    const [userFavorites, setUserFavorites] = useState([]);

    function addFavoriteHandler(favoriteMeetup) {
        setUserFavorites((prevUserFavorites) => { return prevUserFavorites.concat(favoriteMeetup) });
        // console.log("favoriteMeetup", favoriteMeetup);
        // console.log("userFavorites", userFavorites);
        // localStorage.setItem("meetups", JSON.stringify(userFavorites.concat(favoriteMeetup)));
    }


    function removeFavriteHandler(meetupId) {
        setUserFavorites(prevUserFavorites => {
            return prevUserFavorites.filter(meetup => meetup.id !== meetupId);
        });
        localStorage.removeItem("meetups")
    }
    function itemIsFavoriteHandler(meetupId) {
        return userFavorites.some(meetup => meetup.id === meetupId);
    }

    const context = {
        favorites: userFavorites,
        totalFavorites: userFavorites.length,
        addFavorite: addFavoriteHandler,
        removeFavorite: removeFavriteHandler,
        itemIsFavorite: itemIsFavoriteHandler
    };



    return <FavoritesContext.Provider value={context} >
        {props.children}
    </FavoritesContext.Provider>
}


export default FavoritesContext;